
import CardLayout from "../Layout/CardLayout";
import React from "react";
import InversionTable from "./InversionTable";

const InversionComputadoras = (ciemId) => {

    const contributionForm =
        <InversionTable optionName={"inversionComputadorasTable"}
                  ciemId={ciemId}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionComputadorasTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionComputadoras;